module.exports = __webpack_public_path__ + "20250721160708/img/feedback.5c807918.png";